import { useState } from 'react';

import {
  DestructiveDialog,
  Input,
  Typography,
  Box,
  Stack,
  tokens,
} from '@cast/design-system';

export type DisconnectSlackWorkspaceDialogProps = {
  workspace: { id: string; name: string };
};

export const DisconnectSlackWorkspaceDialogContent = ({
  workspace,
}: DisconnectSlackWorkspaceDialogProps) => {
  const [isEnabled, setIsEnabled] = useState(false);

  return (
    <DestructiveDialog
      testId="disconnect-slack-workspace-dialog"
      title="Disconnect Slack workspace"
      message={
        <>
          <Typography variant="P12R" color="textSecondary" mb={16}>
            Disconnecting this workspace will stop alerts configured to use it
            from being sent to Slack. This cannot be undone.
          </Typography>
          <Stack gap={8}>
            <Typography variant="A1" mb={4}>
              Confirm action
            </Typography>
            <Typography variant="P12R" color="textSecondary" mb={16}>
              Please confirm you want to disconnect this workspace by entering
              its name below.
            </Typography>
            <Box
              sx={{
                backgroundColor: tokens.theme.bg.structural.surfaceSubtle,
                color: 'text.secondary',
                padding: '0 12px',
                lineHeight: '30px',
                border: '1px solid',
                borderColor: tokens.theme.border.structural.neutral,
                borderRadius: '4px',
              }}
            >
              {workspace.name}
            </Box>
            <Input
              testId="disconnect-slack-workspace-input"
              onChange={(_, value) =>
                setIsEnabled(workspace.name?.trim() === value?.trim())
              }
              placeholder="Re-enter workspace name here to confirm"
            />
          </Stack>
        </>
      }
      confirmButtonText="Disconnect"
      onConfirm={() => {}}
      slotProps={{
        confirmButton: {
          testId: 'disconnect-slack-workspace-disconnect-button',
          disabled: !isEnabled,
        },
        cancelButton: {
          testId: 'disconnect-slack-workspace-cancel-button',
        },
      }}
    />
  );
};
